// Logging levels in winston conform to the severity ordering specified
// by RFC5424: severity of all levels is assumed to be numerically ascending
// from most important to least important.
export enum LogLevels {
    Error = 0,
    Warn,
    Info,
    Debug,
    Trace,
}

export interface ILogger {
    error(message?: any, ...optionalParams: any[]): void;
    warn(message?: any, ...optionalParams: any[]): void;
    info(message?: any, ...optionalParams: any[]): void;
    debug(message?: any, ...optionalParams: any[]): void;
    trace(message?: any, ...optionalParams: any[]): void;
}

class NoOpLogger implements ILogger {
    error(): void {}

    warn(): void {}

    info(): void {}

    debug(): void {}

    trace(): void {}
}

export class Logger {
    public logger: ILogger;
    public logLevel: LogLevels;
    public getLogLevel: () => LogLevels;

    constructor() {
        this.logger = new NoOpLogger();
        this.logLevel = LogLevels.Debug;
        this.getLogLevel = () => this.logLevel;
    }

    log(message: any, ...args: any[]) {
        this.debug(message, ...args);
    }

    error(message: any, ...args: any[]) {
        if (this.getLogLevel() >= LogLevels.Error) {
            this.logger.error(message, ...args);
        }
    }

    warn(message: any, ...args: any[]) {
        if (this.getLogLevel() >= LogLevels.Warn) {
            this.logger.warn(message, ...args);
        }
    }

    info(message: any, ...args: any[]) {
        if (this.getLogLevel() >= LogLevels.Info) {
            this.logger.info(message, ...args);
        }
    }

    debug(message: any, ...args: any[]) {
        if (this.getLogLevel() >= LogLevels.Debug) {
            this.logger.debug(message, ...args);
        }
    }

    trace(message: any, ...args: any[]) {
        if (this.getLogLevel() >= LogLevels.Trace) {
            this.logger.trace(message, ...args);
        }
    }
}
